import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	faRightFromBracket,
	faEnvelope
} from "@fortawesome/free-solid-svg-icons"

import { useState } from 'react'
import { useNavigate } from 'react-router-dom'


const Public = () => {

	const navigate = useNavigate()

	const [hepid, setHepid] = useState('')

	const handleUserInput = (e) => setHepid(e.target.value)

	const handleSubmit = () => navigate(`/portal/${hepid}`)


	const content = (
		<>
			<section id="main_content">
				<header className="text-steel mt-5">
					<h1>Reset-Wellness Home Programs</h1>
				</header>
				<main>
					<h3 className='mt-5'>This is a sample MERN project.</h3>


					<div id="accordion" style={{ paddingTop: "20px" }}>

						<div className="card">
							<div className="card-header">
								<a className="collapsed btn" data-bs-toggle="collapse" href="#dpe">
									<strong>What is DPE</strong>
								</a>
							</div>
							<div id="dpe" className="collapse show" data-bs-parent="#accordion">
								<div className="card-body">
									DPE, Digital Patient Engagement, is a program for Therapists to create Home Programs (HEP) for their patients.
									Programs can be printed, or emailed to the client.
									Users have the option to mark certain exercises as a "favorite", a good example of state management and editing records without re-loading the page.
									The App also has a built-in ToDo list, which shows some dynamic CSS functions and editing data inside a table.
								</div>
							</div>
						</div>

						<div className="card">
							<div className="card-header">
								<a className="btn" data-bs-toggle="collapse" href="#products">
									Products used
								</a>
							</div>
							<div id="products" className="collapse" data-bs-parent="#accordion">
								<div className="card-body">
									<ul>
										<li>MongoDB for noSQL database</li>
										<li>Express.js as web framework</li>
										<li>React frontend, using Javascript, and with Redux for state management</li>
										<li>Node runtime environment, including its file-system functions</li>
										<li>Bootstrap 5.3 controls css styling, now with the Dark theme option</li>
										<li>JWT is used for authentication and authorization</li>
										<li>Toastify is used for alerts</li>
										<li>FontAwesome icons are used in this app as well, using css to apply colors and sizing</li>
										<li>TinyCME is used for our HTML-enabled email functions, combined with Resend.com to send the emails</li>
										<li>React file-upload, for attachments to emails, is included as well.</li>
									</ul>
								</div>
							</div>
						</div>

						<div className="card">
							<div className="card-header">
								<a className="collapsed btn" data-bs-toggle="collapse" href="#edit">
									Multiple ways to edit data
								</a>
							</div>
							<div id="edit" className="collapse" data-bs-parent="#accordion">
								<div className="card-body">
									The app shows 3 ways to edit table-data.
									First, we can open a new page to edit the data;
									Secondly, we can edit data inside the table;
									Thirdly, we can use a Modal that pops up, to edit the data.
								</div>
							</div>
						</div>

						<div className="card">
							<div className="card-header">
								<a className="collapsed btn" data-bs-toggle="collapse" href="#roles">
									Authentication and roles
								</a>
							</div>
							<div id="roles" className="collapse" data-bs-parent="#accordion">
								<div className="card-body">
									Role-based authorization is used throughout the app, for example: <br />
									Different therapists can log in and review their own Home Programs, but can not see the programs from other providers.
									Managers can only see their staff members, and can view the home program of all their staff members.
									Admin users can review all therapists and all of the programs. Only Admin users can change, and add execises, or users to the program.
								</div>
							</div>
						</div>
					</div>

				</main>
				<footer>
					<div className='row mt-5'>
						<div className='col-md-12'>
							<Link to="/login" className="btn btn-steel">
								<FontAwesomeIcon icon={faRightFromBracket} />
								Login
							</Link>
							<Link to="/contactus" className="btn btn-steel" style={{ marginLeft: "10px" }}>
								<FontAwesomeIcon icon={faEnvelope} />
								Contact Us
							</Link>
						</div>
					</div>
					
					{/*
					<div className='row mt-5'>
						<div className='col-md-7'>
							<label className="form-label">Got a home program?</label>
						</div>
					</div>
					<div className='row mt-1'>
						<div className='col-md-4'>
							<input className='form-control' value={hepid} onChange={handleUserInput} placeholder='Enter Code here' />
						</div>
						<div className='col-md-3'>
							<button className="btn btn-steel" onClick={handleSubmit}>Show Exercises</button>
						</div>
					</div>
					*/}
					
				</footer>
			</section>
		</>

	)
	return content
}
export default Public